import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  Typography,
  Grid,
  Divider,
} from '@mui/material'

export const EmrReportSettingsForm = ({
  emrEditorProperties,
  metaEmrReportTypes,
  categories,
  tabOptions,
  onFieldUpdate,
  reportTypeId,
}) => {
  const {
    emrReportType = '',
    specializations = [],
    tabIds = [],
    onEventCompletedTab = '',
    onEventNotStartedTab = '',
    onEventInProgressTab = '',
  } = emrEditorProperties || {}

  const handleChange = (fieldName, value) => {
    onFieldUpdate(reportTypeId, fieldName, value)
  }

  const selectedSpecializations = categories?.filter((cat) => specializations?.includes(cat.id))

  console.log({ categories })

  const selectedTabIds = tabOptions?.filter((tab) => tabIds?.includes(tab.id))

  return (
    <Box sx={{ mb: 3 }}>
      {/* Section 1: Report Configuration */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
          Report Configuration
        </Typography>
        <Grid container spacing={2}>
          {/* <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Report Type</InputLabel>
              <Select
                value={emrReportType}
                label="Report Type"
                variant="standard"
                onChange={(e) => handleChange('emrReportType', e.target.value)}
              >
                {metaEmrReportTypes?.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid> */}
          {/* <Grid item xs={12} md={6}>
            <Autocomplete
              multiple
              options={(categories || [])?.filter(
                (cat) => cat?.categoryType === 'therapist' || cat?.categoryType === 'doctor',
              )}
              variant="standard"
              getOptionLabel={(option) => option.title || ''}
              value={selectedSpecializations}
              onChange={(event, newValue) => {
                handleChange(
                  'specializations',
                  newValue.map((item) => item.id),
                )
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Specializations"
                  placeholder="Select specializations"
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
          </Grid> */}
        </Grid>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Section 2: Visible Tabs */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
          Visible Tabs
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Select which tabs should be displayed in this report
        </Typography>
        <Autocomplete
          multiple
          options={tabOptions || []}
          variant="standard"
          getOptionLabel={(option) => option.label || ''}
          value={selectedTabIds}
          onChange={(event, newValue) => {
            handleChange(
              'tabIds',
              newValue.map((item) => item.id),
            )
          }}
          renderInput={(params) => (
            <TextField {...params} label="Available Tabs" placeholder="Select tabs" />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Section 3: Event-based Tab Behavior */}
      <Box>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
          Emr launch behaviour
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Configure what to show on the drawer based on launching the emr based on the appointment
          status.
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>For a Completed Session</InputLabel>
              <Select
                value={onEventCompletedTab}
                variant="standard"
                label="For a Completed Session"
                onChange={(e) => handleChange('onEventCompletedTab', e.target.value)}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {tabOptions?.map((tab) => (
                  <MenuItem key={tab.id} value={tab.id}>
                    {tab.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>For a Not Started Session</InputLabel>
              <Select
                value={onEventNotStartedTab || ''}
                variant="standard"
                label="For a Not Started Session"
                onChange={(e) => handleChange('onEventNotStartedTab', e.target.value)}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {tabOptions?.map((tab) => (
                  <MenuItem key={tab.id} value={tab.id}>
                    {tab.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>For an In Progress Session</InputLabel>
              <Select
                value={onEventInProgressTab || ''}
                variant="standard"
                label="For an In Progress Session"
                onChange={(e) => handleChange('onEventInProgressTab', e.target.value)}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {tabOptions?.map((tab) => (
                  <MenuItem key={tab.id} value={tab.id}>
                    {tab.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
